//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Checkbox from '../../../components/checkbox/Checkbox';
import { translate } from "react-i18next";
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';
import TextInput from './../../../components/TextInput';
import loading from './../../../utilities/loading';
import { signIn } from './../../../actions/auth';
import { clearMessage } from './../../../actions/auth';
import messageManager from './../../../utilities/messageManager';
import PoweredInfo from './../../../components/PoweredInfo';

const Wrapper = styled.form`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 215px;
`;

type State = {
    login: string,
    password: string,
    rememberSelected: boolean,
    loginDisabled: boolean,
};

type Values = {
    login: string,
    password: string,
    rememberSelected: boolean
};

type Target = {
    name: string,
    value: string
};

type Props = {
    axiosInstance: any,
    remember: boolean,
    signIn: (login: string, password: string, remember: boolean) => {},
    t: (text: string) => {},
};

export class SignInForm extends React.Component<Props, State> {
    constructor(): void {
        super();

        this.state = {
            login: '',
            invalidLogin: false,
            password: '',
            invalidPassword: false,
            rememberSelected: false,
            loginDisabled: false,
        };
    }

    componentDidUpdate() {
        const { message, clearMessage, t } = this.props;

        if (message.text !== "" && this.state.loginDisabled !== false) {
            messageManager.show({
                text: t(message.text),
                type: 'error',
            })

            setTimeout(() => {
                clearMessage();
            }, 4000)
            this.setState({ loginDisabled: false })
        }
    }

    handleInput(event: SyntheticInputEvent<HTMLInputElement>): void {
        const { name, value }: Target = event.target;

        this.setState({
            [name]: value
        });
    }

    validateForm(): boolean {
        const { password, login } = this.state;
        let invalidPassword = false,
            invalidLogin = false;
        if (!password)
            invalidPassword = true;
        if (!login)
            invalidLogin = true;
        this.setState({
            invalidPassword: invalidPassword,
            invalidLogin: invalidLogin
        });
        return (!invalidPassword && !invalidLogin);
    }

    handleSubmit(): void {
        const { signIn }: Props = this.props;
        const { login, password, rememberSelected }: Values = this.state;
        this.validateForm();
        if (!login) {
            return;
        }
        if (!password) {
            return;
        }
        signIn(login, password, rememberSelected);
        loading.start();
        this.setState({ loginDisabled: true })
    }

    render(): React.Node {
        const { login, invalidLogin, password, invalidPassword, rememberSelected, loginDisabled }: Values = this.state;
        const { t, registerGuestAllowed }: Props = this.props;
        return (<React.Fragment>
            <Wrapper onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleSubmit();
            }}>
                <input type="submit" value="Submit" style={{ display: 'none' }} />
                <TextInput
                    style={{
                        width: '260px',
                        marginBottom: '10px',
                    }}
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    required
                    invalid={invalidLogin}
                    ignoreFocus={true}
                    name="login"
                    tip={t("Login could not be empty")}
                    value={login}
                    onBlur={event => {
                        if (login === "")
                            this.setState({ invalidLogin: true })
                        else
                            this.setState({ invalidLogin: false })
                    }}
                    onChange={event => {
                        this.handleInput(event);
                    }} />
                <TextInput
                    style={{
                        width: '260px',
                        marginBottom: '10px',
                    }}

                    type="password"
                    placeholder={t('Password')}
                    required
                    ignoreFocus={true}
                    invalid={invalidPassword}
                    name="password"
                    tip={t("Password could not be empty")}
                    value={password}
                    onBlur={event => {
                        if (password === "")
                            this.setState({ invalidPassword: true })
                        else
                            this.setState({ invalidPassword: false })
                    }}
                    onChange={event => {
                        this.handleInput(event);
                    }} />

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '280px',
                        marginBottom: '5px',
                    }}>
                    <Checkbox
                        style={{
                            fontSize: '14px',
                        }}
                        label={t('remember')}
                        checked={rememberSelected}
                        onClick={() => {
                            this.setState({ rememberSelected: !rememberSelected });
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                this.setState({ rememberSelected: !rememberSelected });
                            }
                        }} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '280px',
                        marginBottom: '10px',
                    }}>
                    <Link
                        style={{
                            textDecoration: 'none',
                            color: '#757575',
                            fontSize: '14px',
                        }}
                        to='/forgot_password'>
                        {t('forgot password')}
                    </Link>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '280px',
                        marginBottom: '10px',
                    }}>
                    <Link
                        style={{
                            textDecoration: 'none',
                            color: '#757575',
                            fontSize: '14px',
                        }}
                        to='/resend_link'>
                        {t('lost activation link')}
                    </Link>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        marginTop: 'auto',
                        marginBottom: '2px',
                    }}>
                    <Link
                        style={{
                            textDecoration: 'none',
                            color: '#265a9c',
                        }}
                        to='/register'>
                        <GhostButton
                            style={{
                                height: '30px',
                                marginRight: '5px'
                            }}
                            visible={registerGuestAllowed}
                        >
                            {t('create account')}
                        </GhostButton>
                    </Link>
                    <DefaultButton
                        style={{
                            width: '90px',
                            padding: '5px',
                            marginLeft: '5px',
                        }}
                        disabled={loginDisabled}
                        onClick={() => {
                            this.handleSubmit();
                        }}>
                        {t('signIn')}
                    </DefaultButton>
                </div>
            </Wrapper>
            <PoweredInfo />
        </React.Fragment>)
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    message: state.auth.get('message'),
    registerGuestAllowed: state.domainProperties.get('registerGuestAllowed')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    signIn,
    clearMessage,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(SignInForm));


// WEBPACK FOOTER //
// ./src/containers/signIn/signInForm/SignInForm.jsx